import { action, observable } from 'mobx'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import CheckLoginStatus from '../../conditions/CheckLoginStatus'
import DashboardLayout from '../../layouts/DashboardLayout'
import patient from '../../stores/patient'
import AddPatientModal from './AddPatientModal'
import List from './List'

@observer
export default class Demo extends Component {
  @observable addPatientShown = false

  @action
  toggleAddPatient = () => {
    this.addPatientShown = !this.addPatientShown
  }

  componentDidMount() {
    patient.reset()
  }

  render() {
    return (
      <CheckLoginStatus loggedOutRedirect="/">
        {this.addPatientShown && <AddPatientModal toggleAddPatient={this.toggleAddPatient} />}
        <DashboardLayout title="Demo">
          {/* <SectionHeader color="dark-blue" str="titles.yourPatients" icon="fas fa-users" /> */}
          <List toggleAddPatient={this.toggleAddPatient} />
        </DashboardLayout>
      </CheckLoginStatus>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Demo/index.js